import { render, staticRenderFns } from "./BuyHome.vue?vue&type=template&id=51e908ea&"
import script from "./BuyHome.vue?vue&type=script&lang=js&"
export * from "./BuyHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports